import { createContext, useContext, useMemo } from 'react';
import { messages } from './messages';

const I18nContext = createContext(null);

export function I18nProvider({ language, children }) {
  const value = useMemo(() => ({
    language,
    locale: language === 'en' ? 'en-US' : 'es-AR',
    t: messages[language] || messages.es,
  }), [language]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const value = useContext(I18nContext);
  if (!value) {
    throw new Error('useI18n must be used inside I18nProvider');
  }
  return value;
}
